import { CloudSync, CloudSyncOutlined } from '@mui/icons-material'
import React from 'react'
import { Link } from 'react-router-dom'

const Logo = () => {
    return (
        <div className="logo">
            <Link to="/">
                <CloudSyncOutlined />
                <p style={{ color: '#000' }}>
                    <span>Integrated</span>
                    <span>Data Sharing Portal</span>
                </p>
            </Link>
        </div>
    )
}

export default Logo